import React, { type PropsWithChildren, useEffect, useRef, useState, HTMLAttributes } from "react";
import cn from "classnames";

interface ModalProps extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  onClose?: () => void;
}

export const Modal = (props: ModalProps) => {
  const { active, onClose, children, className, ...otherProps } = props;

  const contentRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(active);

  useEffect(() => {
    setOpen(active);
  }, [active]);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && open) {
        onClose?.();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);

  if (!open) return;

  const onCloseModal = (event: React.MouseEvent<HTMLDivElement>) => {
    if (contentRef.current && event.target === contentRef.current) {
      onClose?.();
    }
  };

  return (
    <div
      ref={contentRef}
      role="button"
      onClick={onCloseModal}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0000004b]"
    >
      <div className={cn("scrollbar-none overflow-y-auto p-5", className)} {...otherProps}>
        {children}
      </div>
    </div>
  );
};
